// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"ce9c376f","377":"d01f3945","928":"ec7d060b","973":"ccc103f4"}[chunkId] + ".chunk.js";
};